import { Spin } from "antd";
import React from "react";

export const LoadingSpinner = () => {
  return (
    <div className="loading_screen">
      <Spin size="large" />
    </div>
  );
};
